export default __webpack_public_path__ + "static/media/office2-afterB-1440w.3abd7abb.webp";